import { useState } from "react";
import { format, parse } from "date-fns";
import { Calendar as CalIcon, Clock } from "lucide-react";
import { ptBR } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";

/**
 * DateTimePicker — value: ISO string, onChange: (iso) => void
 */
export default function DateTimePicker({ value, onChange, placeholder = "Selecione a data e hora" }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value) : undefined;
  const timeStr = date ? format(date, "HH:mm") : "";

  const setDate = (d) => {
    if (!d) { onChange(""); return; }
    const base = date || new Date();
    const newD = new Date(d);
    newD.setHours(base.getHours(), base.getMinutes(), 0, 0);
    onChange(newD.toISOString());
  };

  const setTime = (t) => {
    if (!t) return;
    const [hh, mm] = t.split(":");
    const base = date || new Date();
    base.setHours(parseInt(hh) || 0, parseInt(mm) || 0, 0, 0);
    onChange(new Date(base).toISOString());
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="w-full justify-start font-sans-ui text-sm border-zinc-300 rounded-none"
          data-testid="datetime-trigger"
        >
          <CalIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "dd 'de' MMMM 'de' yyyy 'às' HH:mm", { locale: ptBR }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-none border-zinc-300" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          locale={ptBR}
          initialFocus
        />
        <div className="border-t border-zinc-200 p-3 flex items-center gap-2">
          <Clock size={14} className="text-zinc-500" />
          <input
            type="time"
            value={timeStr}
            onChange={(e) => setTime(e.target.value)}
            className="flex-1 border border-zinc-300 px-2 py-1 font-sans-ui text-sm"
            data-testid="datetime-time"
          />
          {date && (
            <Button type="button" variant="ghost" size="sm" onClick={() => { onChange(""); setOpen(false); }} className="text-xs">
              Limpar
            </Button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
